import React, { Component } from "react";
import { HelpBlock, FormGroup, FormControl, Panel, PanelGroup, ControlLabel } from "react-bootstrap";
import RenderLander                from "../../components/utils/RenderLander";
import { Colors }                  from "../../utils/Colors"
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import { getImgOrDocTag }          from "../../utils/ImageUpload";
import { WhiteLabel }              from "../../utils/WhiteLabelProps";
import LoaderButton                from "../../components/LoaderButton";
import ModalAlert                  from "../../components/modal/ModalAlert";
import { invokeAddClientProgress } from "../../utils/AwsInvoke";
import { s3PublicUpload }          from "../../libs/awsLib";
import "../../css/progress/Tracker.css";

const Compress = require('compress.js');
// Initialization
const compress = new Compress()
WhiteLabel();

export default class Tracker extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
          title: "Workout on " + this.todaysDate(),
          showModalAlert:      false, // true | false
          form_submitted: false,
          question1: "",
          question2: "",
          question3: "",
          question4: "",
          question5: "",
          question6: "",
          question7: "",
          questionA: "",
          questionB: "",
          questionC: "",
          questionD: "",
          questionE: "",
          questionF: "",
          questionG: "",
          questionH: "",
          questionI: "",
          questionJ: "",
          questionK: "",
          questionL: "",
          questionM: "",
          questionN: "",
          questionO: "",
          questionP: "",
          questionQ: "",
          notes: "",
          inputValue: "",
        };
    }

    todaysDate = () => {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();

        if(dd<10) dd = '0'+dd
        //if(mm<10) mm = '0'+mm

        today = mm + '/' + dd;
        return today;
    }

    validateForm() {
        //return (
          //this.state.email.length > 0 &&
          //this.state.password.length > 0
        //);
    }

    handleTitleChange = event => {
        this.setState({
            title: event.target.value
        });
    }

    handleQuestion1Change = event => {this.setState({ question1: event.target.value })}
    handleQuestion2Change = event => {this.setState({ question2: event.target.value })}
    handleQuestion3Change = event => {this.setState({ question3: event.target.value })}
    handleQuestion4Change = event => {this.setState({ question4: event.target.value })}
    handleQuestion5Change = event => {this.setState({ question5: event.target.value })}
    handleQuestion6Change = event => {this.setState({ question6: event.target.value })}
    handleQuestion7Change = event => {this.setState({ question7: event.target.value })}

    handleQuestionAChange = event => {this.setState({ questionA: event.target.value })}
    handleQuestionBChange = event => {this.setState({ questionB: event.target.value })}
    handleQuestionCChange = event => {this.setState({ questionC: event.target.value })}
    handleQuestionDChange = event => {this.setState({ questionD: event.target.value })}
    handleQuestionEChange = event => {this.setState({ questionE: event.target.value })}
    handleQuestionFChange = event => {this.setState({ questionF: event.target.value })}
    handleQuestionGChange = event => {this.setState({ questionG: event.target.value })}
    handleQuestionHChange = event => {this.setState({ questionH: event.target.value })}
    handleQuestionIChange = event => {this.setState({ questionI: event.target.value })}
    handleQuestionJChange = event => {this.setState({ questionJ: event.target.value })}
    handleQuestionKChange = event => {this.setState({ questionK: event.target.value })}
    handleQuestionLChange = event => {this.setState({ questionL: event.target.value })}
    handleQuestionMChange = event => {this.setState({ questionM: event.target.value })}
    handleQuestionNChange = event => {this.setState({ questionN: event.target.value })}
    handleQuestionOChange = event => {this.setState({ questionO: event.target.value })}
    handleQuestionPChange = event => {this.setState({ questionP: event.target.value })}
    handleQuestionQChange = event => {this.setState({ questionQ: event.target.value })}

    handleNotesChange = event => {
        this.setState({
            notes: event.target.value
        });
    }

    handleSubmit = async event => {
          event.preventDefault();

          this.setState({ isLoading: true, showLoadingBar: "inline" });
          var title                       = this.state.title;
          var notes                       = this.state.notes;
          var height                      = this.state.question1;
          var weight                      = this.state.question2;
          var lean_tissue_mass_percent    = this.state.question3;
          var lean_tissue_mass_weight     = this.state.question4;
          var adipose_tissue_mass_percent = this.state.question5;
          var adipose_tissue_mass_weight  = this.state.question6;
          var bmi                         = this.state.question7;

          var upper_chest      = this.state.questionA;
          var lower_chest      = this.state.questionB;
          var abdomen          = this.state.questionC;
          var waist            = this.state.questionD;
          var hip              = this.state.questionE;
          var thigh_right      = this.state.questionF;
          var thigh_left       = this.state.questionG;
          var calf_right       = this.state.questionH;
          var calf_left        = this.state.questionI;
          var arm_right        = this.state.questionJ;
          var arm_left         = this.state.questionK;
          var arm_flexed_right = this.state.questionL;
          var arm_flexed_left  = this.state.questionM;
          var forearm_right    = this.state.questionN;
          var forearm_left     = this.state.questionO;
          var neck             = this.state.questionP;
          var shoulder         = this.state.questionQ;

          try {

              let photo_id = this.file ? await s3PublicUpload("progress-photos", this.file) : null;

              // If there's an eisting image and a new one hasn't been uploaded, use existing image
              if(photo_id === null || photo_id === undefined)
                  photo_id = this.state.photo_id;

              const results = await invokeAddClientProgress(title, photo_id, notes, height, weight, lean_tissue_mass_percent, lean_tissue_mass_weight,
                                                            adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi,
                                                            upper_chest, lower_chest, abdomen, waist, hip, thigh_right, thigh_left,
                                                            calf_right, calf_left, arm_right, arm_left, arm_flexed_right,
                                                            arm_flexed_left, forearm_right, forearm_left, neck, shoulder);

              if(results.status === true) {
                  this.setState({
                      isLoading: false,
                      showLoadingBar: "none",
                      form_submitted: true
                  });
                  // Your progress was submitted
              } else
                 this.setState({ isLoading: false, showLoadingBar: "none", form_submitted: true });

                 //this.setState({ form_submitted: true });
          } catch (e) {
              alert("Tracker Error: " + e["message"]);
          }

          this.setState({ isLoading: false });
    }

    handleFileChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.file_orig = event.target.files[0];
            var tmp_file_name = this.file_orig.name; // || .size || ".type"
            var file_type = tmp_file_name.substring(tmp_file_name.lastIndexOf(".")+1);

            if(file_type === "jpg" || file_type === "jpeg" || file_type === "gif" || file_type === "png") {
                    this.setState({
                        value: event.target.value
                    });

                    /*****  Do not show this image on web page but upload it to S3;  *****/
                    /*****  it's a compressed version                                *****/
                    const files = [...event.target.files]
                    compress.compress(files, {
                          size: 2,      // the max size in MB, defaults to 2MB
                          quality: .8, // the quality of the image, max is 1,
                          maxWidth: 1000, // the max width of the output image, defaults to 1920px
                          maxHeight: 1000, // the max height of the output image, defaults to 1920px
                          resize: true, // defaults to true, set false if you do not want to resize the image width and height
                    }).then((data) => {
                          const img1 = data[0]
                          const base64str = img1.data
                          const imgExt = img1.ext
                          const file = Compress.convertBase64ToFile(base64str, imgExt)
                          this.file = file;
                    })
                    /*  END Image Compression  */

                    /***  Original file upload without image compression and it displays the image ***/
                    /***   the image shown is not uploaded since there is no "this.file = ..."     ***/
                    let reader = new FileReader();

                    reader.onload = (e) => {
                        var max_width  = "200px";
                        var max_height = "200px";

                        var img_src_tmp = getImgOrDocTag(e.target.result, file_type, max_width, max_height);

                        this.setState({
                            imageSrc: img_src_tmp,
                            fileType: file_type
                        });
                    };
                    reader.readAsDataURL(event.target.files[0]);
            } else {
                var body_text  = "Sorry, you can only upload images (in .jpg or .png format).";
                this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            }
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    renderForm() {
        var body_comp_panel = <Panel id="example-1" expanded={this.state.open}>
                                    <Panel.Heading style={{cursor: "pointer"}}>
                                          <Panel.Title onClick={() => this.setState({ open: !this.state.open})}>
                                                <FontAwesomeIcon icon="balance-scale" style={{position:"relative", top:2, fontSize:20}} />&nbsp;
                                                Optional: Body Composition Metrics
                                          </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Collapse>
                                        <Panel.Body>
                                                <ControlLabel className="loginTFLabels">1. What is your height in inches? </ControlLabel>
                                                <div>Inches (for example: 64.5)</div>
                                                <FormControl
                                                    className="trackerTf" value={this.state.question1} maxLength="5"
                                                    onChange={this.handleQuestion1Change} style={{fontSize:22, width: 125}}
                                                />
                                                <span className="trackerVertSpacer" />

                                                <ControlLabel className="loginTFLabels">2. What is your weight in pounds? </ControlLabel>
                                                <div>Pounds (for example: 150.8)</div>
                                                <FormControl
                                                    className="trackerTf" value={this.state.question2} maxLength="6"
                                                    onChange={this.handleQuestion2Change} style={{fontSize:22, width: 125}}
                                                />
                                                <span className="trackerVertSpacer" />
                                                <ControlLabel className="loginTFLabels">3. What is your lean tissue mass percent? </ControlLabel>
                                                <div>Percent (for example: 92.3)</div>
                                                <FormControl
                                                    className="trackerTf" value={this.state.question3} maxLength="5"
                                                    onChange={this.handleQuestion3Change} style={{fontSize:22, width: 125}}
                                                />
                                                <span className="trackerVertSpacer" />
                                                <ControlLabel className="loginTFLabels">4. What is your lean tissue mass weight? </ControlLabel>
                                                <div> Pounds (for example: 132.8)</div>
                                                <FormControl
                                                    className="trackerTf" value={this.state.question4} maxLength="6"
                                                    onChange={this.handleQuestion4Change} style={{fontSize:22, width: 125}}
                                                />
                                                <span className="trackerVertSpacer" />
                                                <ControlLabel className="loginTFLabels">5. What is your adipose tissue mass percent? </ControlLabel>
                                                <div>Percent (for example: 12.4)</div>
                                                <FormControl
                                                    className="trackerTf" value={this.state.question5} maxLength="5"
                                                    onChange={this.handleQuestion5Change} style={{fontSize:22, width: 125}}
                                                />
                                                <span className="trackerVertSpacer" />
                                                <ControlLabel className="loginTFLabels">6. What is your adipose tissue mass weight? </ControlLabel>
                                                <div>Pounds (for example: 32.8)</div>
                                                <FormControl
                                                    className="trackerTf" value={this.state.question6} maxLength="5"
                                                    onChange={this.handleQuestion6Change} style={{fontSize:22, width: 125}}
                                                />
                                                <span className="trackerVertSpacer" />
                                                <ControlLabel className="loginTFLabels">7. What is your BMI?</ControlLabel>
                                                <div>Body Mass Index</div>
                                                <FormControl
                                                    className="trackerTf" value={this.state.question7} maxLength="5"
                                                    onChange={this.handleQuestion7Change} style={{fontSize:22, width: 125}}
                                                />
                                                <span className="trackerVertSpacer" />
                                                </Panel.Body>
                                        </Panel.Collapse>
                              </Panel>


      var girth_measure_panel = <Panel id="example-2" expanded={this.state.open2}>
                                  <Panel.Heading style={{cursor: "pointer"}}>
                                        <Panel.Title onClick={() => this.setState({ open2: !this.state.open2})}>
                                              <FontAwesomeIcon icon="ruler" style={{position:"relative", top:2, fontSize:20}} />&nbsp;
                                              Optional: Circumference Measurements
                                        </Panel.Title>
                                  </Panel.Heading>
                                  <Panel.Collapse>
                                        <Panel.Body>
                                              <ControlLabel className="loginTFLabels">A. Upper Chest Measurement </ControlLabel>
                                              <div>Around upper lats, below armpits.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionA} maxLength="5"
                                                  onChange={this.handleQuestionAChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">B. Lower Chest</ControlLabel>
                                              <div>At nipple level.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionB} maxLength="5"
                                                  onChange={this.handleQuestionBChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">C. Abdomen</ControlLabel>
                                              <div>Level of umbilicus.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionC} maxLength="5"
                                                  onChange={this.handleQuestionCChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">D. Waist</ControlLabel>
                                              <div>Narrowest part of waist, above umbilicus and below xiphoid process.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionD} maxLength="5"
                                                  onChange={this.handleQuestionDChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">E. Hip</ControlLabel>
                                              <div>Maximal girth of hip, or buttocks above gluteal fold.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionE} maxLength="5"
                                                  onChange={this.handleQuestionEChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">F. Thigh (Right)</ControlLabel>
                                              <div>Maximal girth of thigh, below gluteal fold, legs slightly apart.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionF} maxLength="5"
                                                  onChange={this.handleQuestionFChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">G. Thigh (Left)</ControlLabel>
                                              <div>Maximal girth of thigh, below gluteal fold, legs slightly apart.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionG} maxLength="5"
                                                  onChange={this.handleQuestionGChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">H. Calf (Right)</ControlLabel>
                                              <div>Maximum girth between knee and ankle joint.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionH} maxLength="5"
                                                  onChange={this.handleQuestionHChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">I. Calf (Left) </ControlLabel>
                                              <div>Maximum girth between knee and ankle joint.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionI} maxLength="5"
                                                  onChange={this.handleQuestionIChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">J. Arm (Right) </ControlLabel>
                                              <div>Arm in anatomical position, midway between acromion and olecranon processes.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionJ} maxLength="5"
                                                  onChange={this.handleQuestionJChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">K. Arm (Left) </ControlLabel>
                                              <div>Arm in anatomical position, midway between acromion and olecranon processes.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionK} maxLength="5"
                                                  onChange={this.handleQuestionKChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">L. Arm Flexed (Right)</ControlLabel>
                                              <div>Maximally contracts the biceps muscle, and the largest circumference is measured.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionL} maxLength="5"
                                                  onChange={this.handleQuestionLChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">M. Arm Flexed (Left)</ControlLabel>
                                              <div>Maximally contracts the biceps muscle, and the largest circumference is measured.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionM} maxLength="5"
                                                  onChange={this.handleQuestionMChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">N. Forearm (Right)</ControlLabel>
                                              <div>Maximum girth of forearm, arm hanging downward and slightly away from trunk palms facing forward.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionN} maxLength="5"
                                                  onChange={this.handleQuestionNChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">O. Forearm (Left)</ControlLabel>
                                              <div>Maximum girth of forearm, arm hanging downward and slightly away from trunk palms facing forward.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionO} maxLength="5"
                                                  onChange={this.handleQuestionOChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">P. Neck</ControlLabel>
                                              <div>Largest girth below Adam's apple, perpendicular to axis of neck.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionP} maxLength="5"
                                                  onChange={this.handleQuestionPChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                              <ControlLabel className="loginTFLabels">Q. Shoulder</ControlLabel>
                                              <div>Maximum girth around both deltoid muscles and upper torso.</div>
                                              <FormControl
                                                  className="trackerTf" value={this.state.questionQ} maxLength="5"
                                                  onChange={this.handleQuestionQChange} style={{fontSize:22, width: 125}}
                                              />
                                              <span className="trackerVertSpacer" />
                                        </Panel.Body>
                                   </Panel.Collapse>
                            </Panel>

        var full_form =  <span style={{position:"relative", top:"0px"}}>

                                               <ControlLabel className="loginTFLabels">Title</ControlLabel>
                                               <FormControl
                                                   className="trackerTf" value={this.state.title}
                                                   onChange={this.handleTitleChange} style={{fontSize:22}}
                                               />
                                               <span className="trackerVertSpacer" />

                                               <span style={{width:"100%",  backgroundColor: "#ddd", padding:17,  border:"0px solid #000"}}>
                                                       <label id="documentFile"> Upload Image
                                                               <FormControl onChange = {this.handleFileChange}
                                                                            style    = {{outline:"none", display: "none", fontSize:"16px", width:"100px" /*width = hide text: 'no file chosen' */}}
                                                                            value    = {this.state.inputValue}
                                                                            type     = "file" />
                                                       </label>
                                               </span>
                                               <div className="formLabel pull-left" style={{width:"100%", textAlign:"left", paddingTop:20, paddingBottom: 20}}>
                                                   {this.state.imageSrc}
                                               </div>
                                               <div className="trackerVertSpacer" />
                               <ControlLabel className="loginTFLabels">Notes</ControlLabel>
                               <textarea value     = {this.state.notes}
                                     className = "trackerTf notesTrackerTF"
                                     onChange  = {this.handleNotesChange}
                                     style     = {{height: 120, width: "100%", borderRadius:5, border:"#cdcdcd 1px solid"}} />

                               <br/><br/>

                               { body_comp_panel }
                               { girth_measure_panel }


                               <LoaderButton
                                   block
                                   //disabled={!this.validateForm()}
                                   type        = "submit"
                                   btncolor    = { Colors.ok_button_bg }
                                   fontSize    = {20}
                                   height      = {40}
                                   isLoading   = {this.state.isLoading}
                                   text        = "Submit"
                                   loadingText = "Submitting progress form data …"
                               />
                       </span>

        var show_form = full_form;
        if(this.state.form_submitted) show_form = <span style={{fontSize: 20}}>Thanks, your progress information was submitted.</span>
        return (
          <form onSubmit={this.handleSubmit}>
              <h2>Progress Tracker</h2>
              <br/>


              { show_form }
          </form>
        );
    }

    render() {
        let closeModalAlert        = () => this.setState({ showModalAlert: false }); //close simple modal window

        return (
          <div className="ProgressTracker">
              
            {this.props.isAuthenticated ? this.renderForm() : <RenderLander />}
            {this.state.showModalAlert ?
                <ModalAlert
                    onHide         = {closeModalAlert}
                    alertFunction  = {this.alertFunction}     // custom function to call within modal
                    alertAction    = {this.state.alertAction} // flag used for above function
                    alertObject    = {this.state.alertObject} // vars used for above function
                    showModalAlert = {this.state.showModalAlert}
                    messageTitle   = {this.state.modalAlertTitleText}
                    messageBody    = {this.state.modalAlertBodyText}
                />
            : null}
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/progress/Tracker.js